import { Card, CardContent, Stack } from '@mui/material';
import { Fragment } from 'react';
import { WsIconProps, WsTypoVariants, WsTypography } from 'wisestep-base';

interface ICalculationUnitCard {
  value: string;
  Icon: React.FC<WsIconProps>;
  heading: string;
  currency: string;
  timeSpan: string;
}

const CalculationUnitCard = ({
  value,
  Icon,
  heading,
  currency,
  timeSpan,
}: ICalculationUnitCard) => (
  <Card variant="outlined" sx={{ width: 300 }}>
    <Fragment>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Icon />
          <WsTypography variant={WsTypoVariants.BODY1}>{heading}</WsTypography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <WsTypography bold={true}>
            {value} {currency}
          </WsTypography>
          {timeSpan && <WsTypography bold={true}>/ {timeSpan}</WsTypography>}
        </Stack>
      </CardContent>
    </Fragment>
  </Card>
);

export default CalculationUnitCard;
